import TrfSettingsContainer from "./trf-settings-container";

export default TrfSettingsContainer

